import React from 'react'

import { IProps as IRichText, RichText } from 'marketing-site/src/library/elements/RichText'
import { IRichTextEditor as IContentfulRichText } from 'marketing-site/@types/generated/contentful'

import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { Text } from 'marketing-site/src/library/elements/Text'
import * as Utils from 'marketing-site/src/library/utils'

export const ContentfulRichText = (text: IContentfulRichText) => (
  <div className="rich-text-wrapper">
    <div className="rich-text-content">
      <Text size="body">
        <EntryMarker entry={text}>{() => <RichText {...transformRichText(text)} />}</EntryMarker>
      </Text>
    </div>
    <style jsx>
      {`
        .rich-text-wrapper {
          display: grid;
          max-width: ${Utils.containerMaxWidth};
          margin: 0 auto;
          grid-template-columns: 1fr [content] 12fr 1fr;
        }

        .rich-text-content {
          grid-column: content;
        }
      `}
    </style>
  </div>
)

export function transformRichText({ fields }: IContentfulRichText): IRichText {
  return {
    html: documentToHtmlString(fields.richTextEditor),
    document: fields.richTextEditor,
    behaviour: fields.behaviour,
    listStyle: fields.listStyle,
  }
}
